import Vue from 'vue'
import Vuex from 'vuex'
import admin from "@/store/modules/admin";
import authentication from "@/store/modules/authentication";
import snackbar from "@/store/modules/snackbar";
import stock from "@/store/modules/Stock";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        base_api: "https://papertrading.ir/api/",
        // base_api:"http://localhost:8000/api/",
        base_url: "https://papertrading.ir/",
        // base_url:"http://localhost:8000/",


        confirmation_dialog: {
            show: false,
            color: 0,
            title: "",
            text_start: "",
            item_to_confirm: "",
            text_end: "",
            confirm_action: "",
            action_payload: null,
            success_action:"",
        }
    },
    getters: {},
    mutations: {
        open_confirmation_dialog(state, payload) {
            state.confirmation_dialog = {
                show: true,
                color: payload.color,
                title: payload.title,
                text_start: payload.text_start,
                item_to_confirm: payload.item_to_confirm,
                text_end: payload.text_end,
                confirm_action: payload.confirm_action,
                action_payload: payload.action_payload,
                success_action: payload.success_action
            }
        },
        close_confirmation_dialog(state, payload) {
            state.confirmation_dialog.show = false
        }
    },
    actions: {},
    modules: {
        Admin: admin,
        Authentication: authentication,
        SnackBar: snackbar,
        Stock: stock,

    }
})
